<template>
  <div class="login">
    <div class="form-container">
    <!-- <img src="./Logos/logo_yard_sale.svg" alt="logo" class="logo"> -->

    <form class="form" @submit.prevent="login()">
      <label for="email" class="label" name="email">Correo electrónico</label>
      <input type="email" v-model="email" placeholder="jarvis@gmail.com" class="input input-email" :class="{ 'input-error': authError }" ref="inputEmail" @keydown.enter="enterAsTab" autocomplete="on">

      <label for="password" class="label" name="password">Contraseña</label>
      <div class="password-input">
        <input v-model="password" :type="showPassword ? 'text' : 'password'" placeholder="********" class="input input-password" :class="{ 'input-error': authError }" @keydown.enter="enterAsTab" autocomplete="on">
        <span class="toggle-password" @click="togglePassword">
        <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span>
      </div>
      <span v-if="authError" class="error-message">{{ authError }}</span>

      <input type="submit" value="Acceder" class="primary-button login-button">
      <!-- <a class="" href="">Forgot my password</a> -->
    </form>
    <!-- <input type="button" value="Sign Up" class="secondary-button signup-button"> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      password: '',
      authError: '',
      showPassword: false,
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    login() {
      axios.post('/_auth/in', {
        email: this.email,
        password: this.password,
      })
      .then(response => {
        console.log('entrando1');
        window.location.href = "/";
      })
      .catch(error => {
        this.authError = error.response && error.response.status === 422
          ? (error.response.data.errors.email ? 'Credenciales incorrectas. Verifica tu email y contraseña.' : '')
          : '';
      });
    },
  },
  mounted() {
    this.$refs.inputEmail.focus();
  },
}
</script>


<style lang="scss">
:root {
  --white: #FFFFFF;
  --black: #000000;
  --very-light-pink: #C7C7C7;
  --text-input-field: #F7F7F7;
  --hospital-green: #ACD9B2;
  --sm: 14px;
  --md: 16px;
  --lg: 18px;
}

body {
  margin: 0;
  font-family: 'Quicksand', sans-serif;
}

.login {
  width: 100%;
  height: 100vh;
  display: grid;
  place-items: center;
}

.form-container {
  display: grid;
  grid-template-rows: auto 1fr auto;
  width: 300px;
}

.form {
  display: flex;
  flex-direction: column;
}

.form a {
  font-size: var(--sm);
  text-decoration: none;
  color: var(--hospital-green);
  text-align: center;
}

.logo {
  width: 200px;
  margin-bottom: 20px;
  justify-self: center;
  display: none;
}

.label {
  font-size: var(--sm);
  font-weight: bold;
  margin-bottom: 4px;
}

.input {
  width: 100%;
  height: 30px;
  border: none;
  border-radius: 8px;
  padding: 5px;
  margin-bottom: 12px;
  font-size: var(--md);
  background-color: var(--text-input-field);
}

.input-email {
  margin-bottom: 22px;
}

.primary-button {
  background-color: var(--hospital-green);
  color: var(--white);
  height: 50px;
  width: 100%;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: var(--md);
  font-weight: 550;
}

.secondary-button {
  height: 50px;
  width: 100%;
  margin-top: 50px;
  background-color: var(--white);
  color: var(--hospital-green);
  border: 1px solid var(--hospital-green);
  border-radius: 8px;
  font-size: var(--md);
  font-weight: 550;
  cursor: pointer;
}

.login-button {
  margin-top: 14px;
  margin-bottom: 30px;
}

.password-input {
  position: relative;
}

.toggle-password {
  position: absolute;
  top: 40%;
  right: 10px;
  transform: translateY(-50%);
  cursor: pointer;
}

.input-error {
  border: 1px solid #f06548;
}

.error-message {
  color: #f06548;
  font-size: 0.8em;
  margin-top: 5px;
  display: block;
  text-align: center !important;
}

@media (max-width: 640px) {
  .logo {
      display: block;
  }
  .signup-button {
      position: absolute;
      width: inherit;
      bottom: 25px;
  }
}
</style>
